<template>
  <b-container>
    <div class="app_details">
      <h1>
        MyApps &nbsp;
        <div class="resource-ico" @click="handleResourceBlocksClick">
          <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <circle
                cx="14"
                cy="14"
                r="14"
                fill="var(--theme-color)"
                fill-opacity="0.1"
            />
            <path
                d="M14 6V22"
                stroke="var(--theme-color)"
                stroke-width="2"
                stroke-linecap="round"
            />
            <path
                d="M6 14L22 14"
                stroke="var(--theme-color)"
                stroke-width="2"
                stroke-linecap="round"
            />
          </svg>
        </div>
      </h1>
      <div class="app_list">
        <app-card
            v-for="(anApp, i) in myApps"
            :app="anApp"
            :key="`ac_${i}`"
        />
      </div>
    </div>
    <resources-store
        :modal-id="modalIdResourcesBlocks"
        :tool-types="['myapp']"
        @update-resources="handleUpdateMyApps"
    />
  </b-container>
</template>

<script>
import ResourcesStore from "@/components/common/resourcesStore";
import AppCard from "@/components/common/appCard";
export default {
  name: "Admin_Manage_MyApps",
  components: {
    AppCard,
    ResourcesStore
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    },
    provider: {
      type: Object,
      default: () => {
        return {};
      }
    },
    itemId: {
      type: String,
      default: "add-edit-item-status"
    }
  },
  computed: {
    myApps(){
      return this.provider && this.provider.myApps ? this.provider.myApps : [];
    }
  },
  created() {},
  mounted() {},
  methods: {
    handleUpdateMyApps(apps) {
      debugger;
      if(Array.isArray(apps)) {
        const existingApps = this.provider && this.provider.myApps && Array.isArray(this.provider.myApps)?
            this.provider.myApps : [];

        const mergedMyApps = [...existingApps, ...apps];

       this.$emit("update-provider",
            {
              id: this.provider && this.provider.id ? this.provider.id : null,
              key: "myApps",
              data: mergedMyApps
            });
      }
    },
    handleResourceBlocksClick() {
      this.$bvModal.show(this.modalIdResourcesBlocks);
    },
    handleUpdateApps(apps) {
      if (Array.isArray(apps) && apps.length > 0) {
        this.$store.dispatch("user/updateApps", apps).then(res => {
          this.getApps();
          this.handleMyAppEmailsDownloadSend(apps);

          this.$store.dispatch("user/showNotification", {
            title: "Your apps have been updated",
            description: "You can now start using your apps on the myapps",
            variant: "success"
          });
        });
      }
    },
    handleMyAppEmailsDownloadSend(apps) {
      debugger;
      let emails = [];
      //Set them all fam status to pending
      if (Array.isArray(apps)) {
        apps.forEach(anApp => {
          //@TODO- find  a central location for processing and changing email- maybe
          debugger;
          let myAppName = anApp.name;
          let myAppNameStripped = myAppName.replace(/[^0-9a-z]/gi, "");
          let subject = `Thanks for Downloading ${myAppName}`;
          let fromEmail = `${myAppNameStripped}@heartbeatfam.com`;

          let toEMail =
              this.profile && this.profile.email
                  ? this.profile.email
                  : "savalascolbert@gmail.com";
          let recipientName = this.profile.firstname
              ? this.profile.firstname
              : "";
          let accountName = `HeartBeatFam`; //this user for now

          //- APP SPECIFIC
          const mailIntro = anApp && anApp.toolObj && anApp.toolObj.mail && anApp.toolObj.mail.intro ?
              anApp.toolObj.mail.intro :{} ;
          let actionTagline = mailIntro && mailIntro.actionTagline ? mailIntro.actionTagline:
              "Make memories worthy of sharing with your entire family";
          let actionStatement = mailIntro && mailIntro.actionStatement ? mailIntro.actionStatement:
              `Welcome to the future of ${myAppName}, where your needs and convenience are our top priority.`;

          //-- FEATURES
          let feature1Title = mailIntro && mailIntro.feature1Title ? mailIntro.feature1Title:
              "User-Friendly Interface";
          let feature1Blurb = mailIntro && mailIntro.feature1Blurb ? mailIntro.feature1Blurb:
              "Navigate the app effortlessly with an intuitive and user-friendly interface " +
              "designed for a seamless and enjoyable user experience.";

          let feature2Title = mailIntro && mailIntro.feature2Title ? mailIntro.feature2Title:
              "Multi-Platform Compatibility";
          let feature2Blurb = mailIntro && mailIntro.feature2Blurb ? mailIntro.feature2Blurb:
              " Access the app from various devices and platforms, ensuring you can stay " +
              "connected and productive wherever you go.";

          let feature3Title = mailIntro && mailIntro.feature3Title ? mailIntro.feature3Title:
              "Real-Time Notification";
          let feature3Blurb = mailIntro && mailIntro.feature3Blurb ? mailIntro.feature3Blurb:
              "Stay informed with real-time notifications, alerts, and updates to keep you in the loop and on top of what matters most.";

          let videoTutorialURL = mailIntro && mailIntro.videoTutorial ? mailIntro.videoTutorial:
              "Stay informed with real-time notifications, alerts, and updates to keep you in the loop and on top of what matters most.";

          let theEmail = {
            subject: subject,
            from: {
              email: fromEmail
            },
            to: [
              {
                email: toEMail
              }
            ],
            personalization: [
              {
                email: toEMail,
                data: {
                  name: recipientName,
                  myapp_name: myAppName,
                  account_name: accountName,
                  action_tagline: actionTagline,
                  action_statement: actionStatement,
                  feature1_title: feature1Title,
                  feature1_blurb: feature1Blurb,
                  feature2_title: feature2Title,
                  feature2_blurb: feature2Blurb,
                  feature3_title: feature3Title,
                  feature3_blurb: feature3Blurb,
                  video_tutorial_url: videoTutorialURL
                }
              }
            ],
            template_id: "x2p03478edplzdrn"
          };
          emails.push(theEmail);
        });
      }

      const payload = {
        emails: emails
      };

      if (Array.isArray(apps) && apps.length > 0) {
        this.$store.dispatch("user/sendEmail", payload).then(res => {
          console.log("Emails sent");
        });
      }
    },
    profileBy() {
      return {
        uid: this.profile.userId,
        name: `${this.profile.firstname} ${this.profile.lastname}`,
        imgURL: this.profile.imgURL
      };
    }
  },
  data() {
    return {
      modalIdResourcesBlocks: "block-resources-myapps",
      status: null, //|all | submitted | needs_work | inactive
      roleOptions: [],
      clear: false,
      idx: 0,
      storagePath: "providers_logos_imgs",
      isUpdate: false,
      name: null,
      description: [],
      brand: null,
      url: null,
      comment: null,
      imgURL: null,
      providerData: null,
      modalAddItemId: "add-item-modal",
      fields: [
        {
          key: "index",
          label: "Index",
          sortable: true,
          isAvail: true,
          inDB: null
        },
        {
          key: "user",
          label: "User",
          sortable: false,
          isAvail: true,
          inDB: null
        },
        {
          key: "nickname",
          label: "Nickname",
          sortable: true,
          isAvail: true,
          inDB: null
        },
        {
          key: "role",
          label: "Role",
          sortable: true,
          isAvail: true,
          inDB: null
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          isAvail: true,
          inDB: null
        },
        {
          key: "actions",
          label: "Actions",
          isAvail: false
        },
        {
          key: "_created_at",
          label: "Created",
          isAvail: true,
          inDB: "doc_._created_at",
          formatter: "formattedDate"
        },
        {
          key: "_updated_at",
          label: "Updated",
          isAvail: false,
          inDB: "doc_._updated_at"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.status-box {
  background-color: #a9a6a6;
  border-radius: 15px;
  padding: 10px;
  margin: 15px;
}
.app_details {
  margin-top: 16px;
  font-family: "Nunito", sans-serif;
  h1 {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    display: flex;
    align-items: center;
    letter-spacing: 0.05em;

    color: #474d52;
  }
  .transactions {
    margin-top: 10px;
    margin-bottom: 20px;
    @media (max-width: 420px) {
      flex-direction: column;
      align-items: center;
    }
    h5 {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      display: flex;
      align-items: center;

      color: #8d99a0;
      margin: 0;
    }
    .transaction_details {
      display: flex;
      align-items: center;
      @media (max-width: 600px) {
        flex-wrap: wrap;
      }
      @media (max-width: 420px) {
        flex-direction: column;
        align-items: center;
      }
      h6 {
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        display: flex;
        margin-bottom: 0;
        align-items: center;
        color: #8d99a0;
        justify-content: center;
        margin-right: 38px;
        width: 120px;
        @media (max-width: 530px) {
          margin-right: 28px;
        }
        @media (max-width: 420px) {
          margin-right: 0px;
        }
      }
      .date_btn {
        cursor: pointer;
        position: relative;
        max-width: 224px;
        width: 100%;
        height: 35px;
        background: #f3f6f9;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        color: #474d52;
        line-height: 35px;
        &:hover {
          background: rgba(85, 126, 251, 0.1);
        }
        @media (max-width: 420px) {
          margin-bottom: 10px;
          padding: 0 10px;
        }

        .calender {
          padding-right: 12px;
        }
        .down {
          padding-left: 12px;
        }
      }
      .email_btn,
      .download_btn {
        background: rgba(85, 126, 251, 0.1);
        border-radius: 4px;
        // max-width: 87px;
        // width: 100%;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        color: var(--theme-color);
        padding-left: 10px !important;
        padding-right: 10px;
        border: none;
        margin-left: 12px;
        &.download {
          max-width: 120px;
          &:hover {
            background: rgba(85, 126, 251, 0.1) !important;
          }
        }
        @media (max-width: 530px) {
          margin-left: 0px;
        }
        @media (max-width: 420px) {
          margin-left: 0px;
        }
        span {
          padding-right: 8px;
        }
        &:focus {
          outline: none;
          border: none;
        }
      }
      .download_btn {
        // max-width: 89px;
        height: 43px;
        width: 100%;
        // justify-content: flex-start;
        background: none;
        @media (max-width: 530px) {
          margin-left: 70px;
        }
        @media (max-width: 420px) {
          margin-left: 0px;
        }
      }
    }
  }
  .app_list {
    //max-width: 915px;
    font-family: "Nunito", sans-serif;
    width: 100%;
    background: #ffffff;
    margin-bottom: 20px;
    margin-top: 20px;
    filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.08));
    border-radius: 8px;
  }
}
</style>
